var _defs, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNovapointLandUsePlanningSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}.cls-2{fill:#009ad9;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NovapointLandUsePlanning_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6,26.55c-.09-.61-.2-1.56-.3-2.78-.85.29-1.71.6-2.54.93-1.08.44-2.14.94-3.19,1.46V32H7.13A51.05,51.05,0,0,1,6,26.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27,26.7c0-2.61-3.9-2.7-3.9-3.72,0-.36.25-.56.78-.56a2.55,2.55,0,0,1,1.51.68l1-1.31a4.2,4.2,0,0,0-2.6-.94c-1.62,0-2.56.91-2.56,2.21a1.79,1.79,0,0,0,.42,1.19,2.24,2.24,0,0,0-1.16,1.84c0,2.71,3.79,2.61,3.79,3.74,0,.36-.27.6-.86.6a2.12,2.12,0,0,1-1.57-.73L20.6,30.78A3.55,3.55,0,0,0,23.39,32c1.8,0,2.77-1,2.77-2.27a1.82,1.82,0,0,0-.35-1.12A2.15,2.15,0,0,0,27,26.7Zm-4.75-.76a.93.93,0,0,1,.51-.84c1.13.56,2.45.86,2.45,1.77a.93.93,0,0,1-.5.85C23.6,27.12,22.25,26.83,22.25,25.94Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.16,5.67a35.21,35.21,0,0,1,6.16,0,31.78,31.78,0,0,1,5.38.91A29.58,29.58,0,0,1,24,7.64V0H10.85C10.2,1.87,9.62,3.75,9.16,5.67Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.44,22.85c1-.42,2.1-.8,3.16-1.15A61.21,61.21,0,0,1,5.87,13,60.15,60.15,0,0,1,8.72,0H0V23.92C.8,23.54,1.62,23.18,2.44,22.85Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,18.16V9.83a27.34,27.34,0,0,0-3.81-1.34,31.73,31.73,0,0,0-5-.85,33.81,33.81,0,0,0-6.44.08c-.37,1.82-.66,3.65-.85,5.49A55.41,55.41,0,0,0,8,26.26,51.28,51.28,0,0,0,9.2,32H16A16,16,0,0,1,24,18.16Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovapointLandUsePlanningSvg);
export default __webpack_public_path__ + "static/media/NovapointLandUsePlanning_svg.66de458c2aa56cc69426c8cb90a409aa.svg";
export { ForwardRef as ReactComponent };